import { render, staticRenderFns } from "./ContentmodulesEditTable.vue?vue&type=template&id=608b7daa&"
import script from "./ContentmodulesEditTable.vue?vue&type=script&lang=js&"
export * from "./ContentmodulesEditTable.vue?vue&type=script&lang=js&"
import style0 from "./ContentmodulesEditTable.vue?vue&type=style&index=0&id=608b7daa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports